import { createBrowserRouter, RouterProvider } from "react-router";

import { locale, defaultLocale } from "../../helpers/translate";
import { intlLocationBasenameFor } from "../Utils/routing";
import MainErrorBoundary from "../ErrorBoundaries/MainErrorBoundary";

import SignUpAppRoute from "../SignUpApp/SignUpAppRoute";

// Define whether there's a locale prefix to the router paths, depending on the current
// locale and default locale of the platform.
const basename = intlLocationBasenameFor({ locale, defaultLocale });

const mainRouter = createBrowserRouter(
  [
    {
      path: "*",
      Component: SignUpAppRoute,
      ErrorBoundary: MainErrorBoundary
    }
  ],
  {
    basename
  }
);

// Note : check whether we need the defineHistoryBasename method
const SignUpAppRouter = () => {
  return <RouterProvider router={mainRouter} />;
};

export default SignUpAppRouter;
